import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import a1 from "../Assets/a1.png";
import a2 from "../Assets/a2.png";
import a3 from "../Assets/a3.png";
import a4 from "../Assets/a4.png";
import a5 from "../Assets/a5.png";
import a7 from "../Assets/a7.png";
const images = [a1, a2, a3, a4, a5, a7];

interface ImageCarouselProps {
  autoPlay?: boolean;
  interval?: number;
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({
  autoPlay = true,
  interval = 3000,
}) => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + images.length) % images.length);
  };

  React.useEffect(() => {
    if (!autoPlay) return;
    const slideInterval = setInterval(nextSlide, interval);
    return () => clearInterval(slideInterval);
  }, [current, autoPlay, interval]);

  return (
    <div className="w-full">
      <div className="relative w-full h-64 md:h-96 overflow-hidden select-none">
        <motion.div
          key={current}
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="w-full h-full"
        >
          <img
            src={images[current]}
            alt="carousel"
            className="w-full h-full object-cover"
          />
        </motion.div>

        <button
          onClick={prevSlide}
          className="absolute top-1/2 -translate-y-1/2 left-3 bg-black/40 hover:bg-black/70 text-white p-2 rounded-full"
        >
          <ChevronLeft />
        </button>

        <button
          onClick={nextSlide}
          className="absolute top-1/2 -translate-y-1/2 right-3 bg-black/40 hover:bg-black/70 text-white p-2 rounded-full"
        >
          <ChevronRight />
        </button>

        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
          {images.map((_, index) => (
            <div
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-3 h-3 rounded-full cursor-pointer ${
                index === current ? "bg-white" : "bg-white/50"
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageCarousel;
